<!--<mat-toolbar>-->
<!--  <mat-form-field class="organizationSelect">-->
<!--    <mat-label>Select an Organization</mat-label>-->
<!--    <mat-select [(value)]="selectedOrganization">-->
<!--      <mat-option *ngFor="let organization of consultantOrganizations" [value]="organization.id">{{organization.orgName}}</mat-option>-->
<!--    </mat-select>-->
<!--  </mat-form-field>-->
<!--</mat-toolbar>-->
<inthraction-side-nav-drawer [menuOptions]="menuOptions" class="consultant-dashboard-drawer"></inthraction-side-nav-drawer>
